// src/TermsPage.jsx
import React from 'react';

export default function TermsPage({ onClose }) {
  return (
    <div style={{ minHeight: '100vh', background: '#fff', padding: '40px 20px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', color: '#1f2937', lineHeight: 1.6, fontSize: 15 }}>
        {/* Back button */}
        <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: '#6b7280', fontSize: 14, cursor: 'pointer', marginBottom: 24, padding: 0 }}>
          ← Back
        </button>

        <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 8 }}>Terms of Service</h1>
        <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 32 }}>Last updated: 25 June 2026</p>

        <p>Welcome to MakeMyResume ("we", "our", "the Service"). By accessing or using the Service at makemyresume.app, you agree to these Terms of Service ("Terms"). If you do not agree, do not use the Service.</p>

        <h2 style={s.h2}>1. The Service</h2>
        <p>MakeMyResume is an online tool that helps users create CVs and resumes using templates, AI assistance, and PDF export. The Service is operated as an individual sole trader business.</p>

        <h2 style={s.h2}>2. Eligibility</h2>
        <p>You must be at least 16 years old to use the Service. By using it, you confirm you meet this requirement.</p>

        <h2 style={s.h2}>3. Accounts</h2>
        <p>Some features require creating an account via Clerk authentication. You are responsible for safeguarding your login credentials and for any activity under your account.</p>

        <h2 style={s.h2}>4. Subscriptions and Payments</h2>
        <p>We offer the following paid plans (prices in EUR, may change with notice):</p>
        <ul style={s.ul}>
          <li><strong>One-Time Access</strong> — €4.99 for 7 days of full access (single payment)</li>
          <li><strong>Pro Monthly</strong> — €6.99/month recurring (cancel anytime)</li>
          <li><strong>Pro Annual</strong> — €34.99/year recurring (cancel anytime)</li>
        </ul>
        <p>Payments are processed by Stripe. By subscribing you agree to be charged the amount and frequency selected at checkout. Recurring subscriptions will automatically renew unless cancelled before the next billing date.</p>

        <h2 style={s.h2}>5. Refunds</h2>
        <p>We offer a 7-day money-back guarantee for monthly and annual subscriptions. To request a refund, email <a href="mailto:support@makemyresume.app" style={s.a}>support@makemyresume.app</a> within 7 days of purchase. One-Time Access purchases are non-refundable once AI features have been used.</p>

        <h2 style={s.h2}>6. Cancellation</h2>
        <p>You can cancel a recurring subscription at any time via your account settings or by contacting support. Cancellation takes effect at the end of the current billing period; no partial refunds are issued for the current period.</p>

        <h2 style={s.h2}>7. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul style={s.ul}>
          <li>Use the Service to create fraudulent, misleading, or illegal CVs.</li>
          <li>Use automated tools (scrapers, bots) to abuse the Service.</li>
          <li>Reverse engineer, copy, or resell the Service or its templates.</li>
          <li>Submit content that infringes intellectual property or contains malicious code.</li>
          <li>Bypass paywalls, AI usage limits, or other technical restrictions.</li>
        </ul>
        <p>We may suspend or terminate accounts that violate these rules.</p>

        <h2 style={s.h2}>8. AI Features</h2>
        <p>AI features (CV enhancement, job tailoring, review) use third-party language models. AI output is generated automatically and may contain errors. You are responsible for reviewing and verifying all AI-generated content before submitting your CV to employers. We do not guarantee job outcomes or interview results.</p>

        <h2 style={s.h2}>9. Intellectual Property</h2>
        <p>You retain full ownership of all content you create with the Service, including your CV text and final PDF exports. We retain ownership of the Service itself, including templates, design, code, and trademarks.</p>

        <h2 style={s.h2}>10. Disclaimer</h2>
        <p>The Service is provided "as is" without warranties of any kind. We do not guarantee that the Service will be uninterrupted, error-free, or meet your specific job-application needs.</p>

        <h2 style={s.h2}>11. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, our total liability to you for any claim arising from the Service is limited to the amount you paid in the 12 months prior to the claim.</p>

        <h2 style={s.h2}>12. Changes</h2>
        <p>We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance. Material changes will be announced via email or on-site notice.</p>

        <h2 style={s.h2}>13. Governing Law</h2>
        <p>These Terms are governed by the laws of Germany. Any disputes will be resolved in the courts of Berlin, Germany.</p>

        <h2 style={s.h2}>14. Contact</h2>
        <p>For questions about these Terms, email <a href="mailto:support@makemyresume.app" style={s.a}>support@makemyresume.app</a>.</p>

        <div style={{ height: 40 }}/>
      </div>
    </div>
  );
}

const s = {
  h2: { fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12, color: '#111827' },
  ul: { paddingLeft: 24, marginBottom: 16 },
  a: { color: '#2563eb', textDecoration: 'underline' }
};
